<template>
  <v-avatar
    :style="style"
    :size="size"
    v-if="item">
    <img
      v-if="item.avatar"
      :src="item.avatar"
      v-img-fallback>
    <span
      v-else-if="firstLetter"
      class="initial white--text">
      {{ firstLetter }} {{ secondLetter !== firstLetter ? secondLetter : null }}
    </span>
    <span
      v-else
      class="white--text headline">
      J
    </span>
    <v-avatar
      v-if="displayDevice"
      class="device"
      :size="27">
      <v-icon small>
        {{ device }}
      </v-icon>
    </v-avatar>
  </v-avatar>
</template>

<script>
import { initialToColor } from '../../../helper/util'

const deviceIcons = {
  'STANDARD': 'laptop_windows',
  'SMARTPHONE': 'smartphone',
  'TABLET': 'tablet'
}

export default {
  props: {
    item: {
      type: Object,
      required: false,
      default: null
    },
    schema: {
      type: Object,
      required: false,
      default: null
    },
    size: {
      type: Number,
      required: false,
      default: 80
    }
  },
  computed: {
    value () {
      return this.item && this.item[this.mainProperty]
    },
    firstLetter () {
      return this.value && this.value.slice(0, 1).toUpperCase()
    },
    secondLetter () {
      if (this.value) {
        const parts = this.value.split(' ')
        const word = parts[1] || parts[0]
        return word.slice(0, 1).toUpperCase()
      }
      return this.firstLetter
    },
    initialColor () {
      return initialToColor(this.firstLetter, this.secondLetter)
    },
    mainProperty () {
      return this.schemaMainProperty ? this.schemaMainProperty.name : 'name'
    },
    schemaMainProperty () {
      return this.schema && this.schema.fields.find(f => f.main)
    },
    preference () {
      return this.item && this.item.preference
    },
    avatarShape () {
      return this.preference && this.preference.custom && this.preference.custom.shape
    },
    style () {
      return {
        minWidth: `${this.size}px`,
        minHeight: `${this.size}px`,
        backgroundColor: (this.preference && this.preference.avatarBackgroundColor) || this.initialColor,
        borderRadius: this.avatarShape === 'rectangle' ? '10%' : undefined
      }
    },
    device () {
      return this.item && this.item.device && this.item.device.name
        ? deviceIcons[this.item.device.name]
        : null
    },
    displayDevice () {
      return this.size >= 60 && this.device
    }
  },
  methods: {
    stringToColor (str) {
      let hash = 0
      for (let i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash)
      }
      let colour = '#'
      for (let i = 0; i < 3; i++) {
        const value = (hash >> (i * 8)) & 0xFF
        colour += ('00' + value.toString(16)).substr(-2)
      }
      return colour
    }
  }
}
</script>

<style lang="scss" scoped>
  .initial {
    font-size: 10px;
  }
  .device {
    background-color: white;
    color: rgba(0,0,0,.54);
    box-shadow: 2px 2px 2px grey;
    position: absolute;
    bottom: 0;
    right: 0;
    .theme--dark.v-icon {
      color: rgba(0,0,0,.54);
    }
  }
</style>
